import type React from 'react';
import { useEffect } from 'react';
import { api, apiStatic, requestError } from 'AurionCR/components';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { authFail } from 'AurionCR/store/modules/auth';
import { getAuthTokens, updateAuthTokens } from 'utils/cookies';

interface AxiosInterceptorsTokenProps {}

export const AxiosInterceptorsToken: React.FC<AxiosInterceptorsTokenProps> = ({ children }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    const ids = [api].map((instance) => {
      const id = instance.interceptors.response.use(
        (response) => {
          // update token
          const { method, url }: any = response.config;
          if (method === 'post') {
            if (url === 'Auth/LoginWithCode') {
              const {
                jwt: { token, refreshToken },
                expires,
              } = response.data;
              updateAuthTokens({ token, refreshToken, expires });
            } else if (url === 'Auth/Logout') {
              updateAuthTokens();
            }
          }
          return response;
        },
        (error) => {
          const {
            config: { url, method },
          } = error;
          if (method === 'get' && url === 'Account/GetCurrentAppUser') {
            updateAuthTokens();
            return dispatch(authFail(error ? requestError(error) : null));
          } else {
            throw error;
          }
        },
      );
      return { id, instance };
    });

    return () => {
      ids.forEach(({ instance, id }) => {
        instance.interceptors.response.eject(id);
      });
    };
  }, [dispatch]);

  useEffect(() => {
    const ids = [api, apiStatic, axios].map((instance) => {
      const id = instance.interceptors.request.use((config) => {
        const { token } = getAuthTokens();

        if (token) {
          config.headers['Authorization'] = 'Bearer ' + token;
        }

        return config;
      });
      return { id, instance };
    });

    return () => {
      ids.forEach(({ instance, id }) => {
        instance.interceptors.request.eject(id);
      });
    };
  }, []);

  return <>{children}</>;
};
